import React from "react";

const ScoreEditModal = ({
  matchId,
  score,
  onChange,
  onCancel,
  onSave,
  team1Name = "Équipe 1",
  team2Name = "Équipe 2",
}) => {
  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50">
      <div className="bg-gray-700 text-white rounded-lg shadow-xl p-6 w-full max-w-md mx-4">
        <h2 className="text-2xl font-bold mb-6 text-center">Modifier le score</h2>

        <div className="flex justify-around gap-2 mb-6 p-4 rounded-lg shadow-xl">
          {/* Team 1 */}
          <div className="flex flex-col items-center gap-3 w-40">
            <div
              className="w-full text-lg font-semibold text-center overflow-hidden"
              style={{
                display: "-webkit-box",
                WebkitLineClamp: 2,
                WebkitBoxOrient: "vertical",
              }}
            >
              {team1Name}
            </div>
            <button
              className="bg-green-500 hover:bg-green-600 text-white text-2xl px-4 py-2 rounded"
              onClick={() => onChange(matchId, "team1", Number(score?.team1) + 1)}
            >
              +
            </button>
            <div className="text-3xl font-bold">{Number(score?.team1) || 0}
            </div>
            <button
              className="bg-red-500 hover:bg-red-600 text-white text-2xl px-4 py-2 rounded"
              onClick={() =>
                onChange(matchId, "team1", Math.max(0, Number(score.team1) - 1))
              }
            >
              −
            </button>
          </div>

          {/* Team 2 */}
          <div className="flex flex-col items-center gap-3 w-40">
            <div
              className="w-full text-lg font-semibold text-center overflow-hidden"
              style={{
                display: "-webkit-box",
                WebkitLineClamp: 2,
                WebkitBoxOrient: "vertical",
              }}
            >
              {team2Name}
            </div>
            <button
              className="bg-green-500 hover:bg-green-600 text-white text-2xl px-4 py-2 rounded"
              onClick={() => onChange(matchId, "team2", Number(score.team2) + 1)}
            >
              +
            </button>
            <div className="text-3xl font-bold">{Number(score?.team2) || 0}
            </div>
            <button
              className="bg-red-500 hover:bg-red-600 text-white text-2xl px-4 py-2 rounded"
              onClick={() =>
                onChange(matchId, "team2", Math.max(0, Number(score.team2) - 1))
              }
            >
              −
            </button>
          </div>
        </div>

        <div className="flex justify-end gap-4">
          <button
            className="px-4 py-2 bg-gray-400 hover:bg-gray-500 text-gray-900 rounded"
            onClick={onCancel}
          >
            Annuler
          </button>
          <button
            className="px-4 py-2 bg-green-600 hover:bg-green-700 text-white rounded"
            onClick={() => onSave(matchId)}
          >
            Enregistrer
          </button>
        </div>
      </div>
    </div>
  );
};

export default ScoreEditModal;
